export const frameNames = frame => {
  switch (frame) {
    case 'frame':
      return 'Obramowanie'
    case 'passe-partout':
      return 'Passe-partout'
    default:
      return 'Brak obramowania'
  }
}

export const frames = ['noframe', 'frame', 'passe-partout']



// WEBPACK FOOTER //
// ./src/components/Frame/names.js